export const TaskAssigneeType = Object.freeze({
  INDIVIDUAL: 'individual',
  TEAM: 'team',
});

export const TaskActionStatus = Object.freeze({
  DEFAULT: 'A',
  ONGOING: 'R',
  IGNORED: 'I',
  CLOSED: 'C',
  // :'A',
  // : 'D',
  // :'E'
});

const actionOptions = [
  'Face-to-face clinic',
  'Phone contact',
  'Face-to-face home visit',
  'Provider interaction',
  'Carer interaction',
  'Other',
];
